<style>
    :global(div.swiper-button-disabled) {
        opacity: 0.5;
    }

    .control-buttons-placement-y {
        top: 45%;
        bottom: auto;
    }

    @media(min-width: 768px) {  
        .control-buttons-placement-y {
           top: auto;
           bottom: 0;
        }
    }
</style>

<div class="tw-relative">
    {#if slides.length > 1}
    <div class="tw-absolute control-buttons-placement-y tw-right-5 tw-z-10">
        <div class='tw-flex'>
            <div data-swiper="prev" class='tw-cursor-pointer'>
                <img loading='eager' height='32' src='https://cdn.shopify.com/s/files/1/0114/4120/9408/files/LEFT.svg?v=1618933362' alt='prev slide' class='tw-transform tw-rotate-180' />
            </div>
            <div data-swiper="next" class='tw-cursor-pointer tw-ml-8 md:tw-ml-4'>
                <img loading='eager' height='32' src='https://cdn.shopify.com/s/files/1/0114/4120/9408/files/LEFT.svg?v=1618933362' alt='next slide' />
            </div>        
        </div>
    </div>
    {/if}
    <Swiper        
        slidesperview={1}
        spacebetween={50} 
        navigation={{nextEl: '[data-swiper=next]', prevEl: '[data-swiper=prev]'}}>
        {#each slides as slide}
            <SwiperSlide>
                <Slide 
                    buttonLink={slide.link} 
                    buttonText={slide.link_text} 
                    header={slide.title} 
                    subHeader={slide.subheading}
                    imageSrc={slide.image}                    
                />
            </SwiperSlide>
        {/each}        
    </Swiper>
</div>
<script>
    // Import Swiper Svelte components
    import SwiperCore, {Navigation} from "swiper";
    import {Swiper, SwiperSlide} from "swiper/svelte";
    import Slide from "./Slide.svelte";
    // Import Swiper styles
    import "swiper/swiper-bundle.min.css";
    import "swiper/components/navigation/navigation.min.css";

    SwiperCore.use([Navigation]);

    export let slides = [];
</script>